import React, { useState } from 'react';
import './ProductComparison.scss';
import CTAButton from '../UI/CTA/CTAButton/CTAButton';
import Loader from '../UI/Icons/Loader/Loader';

/**
 *
 * @param {String} heading
 * @param {Number} features_limit
 * @param {Object} product_one
 * @param {Object} product_two
 * @param {Array} features
 * @param {boolean} isPDP
 * @param {function} addToCart
 * @returns {JSX.Element}
 * @constructor
 */
const ProductComparison = ({
  heading,
  features_limit,
  product_one,
  product_two,
  features,
  isPDP,
  addToCart,
}) => {
  const [loadMore, setLoadMore] = useState(features.length <= features_limit);

  const renderFeatures = () => {
    const filteredFeatures = loadMore ? features : features.slice(0, features_limit);
    return filteredFeatures.map((feature) => (
      <div className="c-product-comparison__feature">
        <h5 className="c-product-comparison__category eyebrow-2 color-black">{feature.category}</h5>
        <div className="c-product-comparison__feature-comparison">
          {product_one && (
            <p className="c-product-comparison__feature-description body-2 color-black">
              {feature.product_one}
            </p>
          )}

          {product_two && (
            <p className="c-product-comparison__feature-description body-2 color-black">
              {feature.product_two}
            </p>
          )}
        </div>
      </div>
    ));
  };

  const [productOneFetching, setProductOneFetching] = useState(false);
  const [productTwoFetching, setProductTwoFetching] = useState(false);

  const addAction = async (properties, product, isProductOne = false) => {
    isProductOne ? setProductOneFetching(true) : setProductTwoFetching(true);

    await addToCart(properties, product.title)
      .then(() => (isProductOne ? setProductOneFetching(false) : setProductTwoFetching(false)))
      .catch(() => {
        isProductOne ? setProductOneFetching(false) : setProductTwoFetching(false);
        console.error('Error fetching, please try again');
      });
  };

  return (
    <div id="compare" className="c-product-comparison background-color-white">
      <div className="c-product-comparison__content">
        <h4 className="c-product-comparison__heading h4-right-grotesk color-black">{heading}</h4>
        <div className="c-product-comparison__trailing">
          <div className="c-product-comparison__products">
            {product_one && (
              <div className="c-product-comparison__product">
                <div className="c-product-comparison__product-info-group">
                  <div className="c-product-comparison__product-info">
                    <h4 className="c-product-comparison__product-title h4-roobert color-black">
                      {product_one.title}
                    </h4>
                    <span className="c-product-comparison__product-price eyebrow-1 color-black">
                      {product_one.price}
                    </span>
                  </div>
                  <div className="c-product-comparison__product-img-container">
                    <img
                      src={product_one.image.url}
                      alt={product_one.image.alt}
                      className="c-product-comparison__product-img"
                    />
                  </div>
                </div>
                {!isPDP && (
                  <div className="c-product-comparison__product-cta">
                    <CTAButton
                      isButton={true}
                      onClick={
                        product_one?.variants[0]?.available
                          ? () =>
                              addAction(
                                {
                                  quantity: 1,
                                  id: product_one.variants[0].id,
                                },
                                product_one,
                                true,
                              )
                          : null
                      }
                      ariaLabel={
                        product_one?.variants[0]?.available
                          ? `Buy–${product_one?.price}`
                          : 'Sold Out'
                      }
                      type="primary"
                      text={
                        product_one?.variants[0]?.available ? (
                          productOneFetching ? (
                            <Loader lightMode={true} />
                          ) : (
                            `Buy–${product_one?.price}`
                          )
                        ) : (
                          'Sold Out'
                        )
                      }
                      additionalClasses="cta"
                      disabled={!product_one?.variants[0]?.available}
                    />
                  </div>
                )}
              </div>
            )}
            {product_two && (
              <div className="c-product-comparison__product">
                <div className="c-product-comparison__product-info-group">
                  <div className="c-product-comparison__product-info">
                    <h4 className="c-product-comparison__product-title h4-roobert color-black">
                      {product_two.title}
                    </h4>
                    <span className="c-product-comparison__product-price eyebrow-1 color-black">
                      {product_two.price}
                    </span>
                  </div>
                  <div className="c-product-comparison__product-img-container">
                    <img
                      src={product_two.image.url}
                      alt={product_two.image.alt}
                      className="c-product-comparison__product-img"
                    />
                  </div>
                </div>
                {!isPDP && (
                  <div className="c-product-comparison__product-cta">
                    <CTAButton
                      isButton={true}
                      onClick={
                        product_two?.variants[0]?.available
                          ? () =>
                              addAction(
                                {
                                  quantity: 1,
                                  id: product_two.variants[0].id,
                                },
                                product_two,
                                false,
                              )
                          : null
                      }
                      ariaLabel={
                        product_two?.variants[0]?.available
                          ? `Buy–${product_two?.price}`
                          : 'Sold Out'
                      }
                      type="primary"
                      text={
                        product_two?.variants[0]?.available ? (
                          productTwoFetching ? (
                            <Loader lightMode={true} />
                          ) : (
                            `Buy–${product_two?.price}`
                          )
                        ) : (
                          'Sold Out'
                        )
                      }
                      additionalClasses="cta"
                      disabled={!product_two?.variants[0]?.available}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="c-product-comparison__features-container">
            {renderFeatures()}

            {loadMore ? null : (
              <button
                className="c-product-comparison__load-more-btn cta color-black"
                onClick={() => setLoadMore(true)}
              >
                + See full details
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductComparison;
